import React, { PureComponent } from 'react';

class RemoteWorkingField extends PureComponent {
    render() {
        const { remoteWorker, setRemoteWorker } = this.props;

        return (
            <div className="fieldwrap ">
                <label htmlFor="remoteWorker">
                    Do you regularly work remotely - at home or off site - for part of the week?
                </label>
                <div className="row">
                    <div className="col-sm-auto">
                        <label
                            onClick={e => setRemoteWorker('yes')}
                            className={
                                remoteWorker == 'yes' ? 'radio __active' : 'radio'
                            }
                        >
                        <input type="radio" name="remoteWorker" /> Yes
                        </label>
                    </div>
                    <div className="col-sm-auto">
                        <label
                            onClick={e => setRemoteWorker('no')}
                            className={
                                remoteWorker == 'no' ? 'radio __active' : 'radio'
                            }
                        >
                        <input type="radio" name="remoteWorker" /> No
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

export default RemoteWorkingField;



// WEBPACK FOOTER //
// ./src/Form/RemoteWorkingField.js